import React, { useState } from "react";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import sanskritilogo from "../assets/images/SANSKRITI_LOGO.png";
import API_URL from "../apiUrl";
import DownloadCSV from "../components/DownloadCSV";


const DownloadAuth = () => {
    const [authError, setAuthError] = useState("");
    const [authSuccess, setAuthSuccess] = useState(false);
    const [otp, setOtp] = useState("");
    const [showDownload, setShowDownload] = useState(false);

    const handleAuth = async (values) => {
        try {
            if(authSuccess){
            if (otp === values.otp)  setShowDownload(true);
             return;
            }   
          const response = await axios.post(
            `${API_URL}users/login`,
            values
          );
          if (response.data.token) {
            setOtp(response.data.otp);
            setAuthSuccess(true);
          } else {
            setAuthError("Invalid username or password");
          }
        } catch (error) {
            setAuthSuccess(false);
          console.error("Error during authentication:", error.message);
          setAuthError("Authentication failed. Please try again.");
        }
      };

    return (
      <div className="flex justify-center items-center flex-col h-screen bg-gray-200">
        <h1 className="text-3xl font-extrabold text-gray-800 text-center mb-6">
          Authenticate to Download Students Data!
        </h1>
        <div className="bg-white p-8 rounded-lg shadow-md">
          <img src={sanskritilogo} alt="logo" className="w-52 h-52 mx-auto" />

          <Formik
            initialValues={{ userId: "", password: "", otp: "" }}
            validationSchema={Yup.object({
              // userId: Yup.string().email("Invalid email").required("Required"),
              // password: Yup.string().required("Required"),
            })}
            onSubmit={handleAuth}
          >
            {({ values, errors, handleChange, handleSubmit }) => (
              <form onSubmit={handleSubmit} className="w-96">
                {!authSuccess && (
                  <div>
                    <div className="mb-2">
                      <label className="text-gray-700 font-bold">
                        User ID:
                      </label>
                      <input
                        type="email"
                        name="userId"
                        value={values.userId}
                        onChange={handleChange}
                        placeholder="Enter Your User ID!"
                        className={`placeholder:text-sm py-2 w-full outline-none rounded-md border-gray-300 shadow-sm ${
                          errors.userId ? "border-red-500" : ""
                        }`}
                        required
                      />
                      {errors.userId && (
                        <div className="text-red-500">{errors.userId}</div>
                      )}
                    </div>
                    <div className="">
                      <label className="text-gray-700 font-bold">
                        Password:
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        placeholder="Enter Password!"
                        className={`py-2 placeholder:text-sm w-full rounded-md outline-none border-gray-300 shadow-sm 0 ${
                          errors.password ? "border-red-500" : ""
                        }`}
                        required
                      />
                      {errors.password && (
                        <div className="text-red-500">{errors.otp}</div>
                      )}
                    </div>
                  </div>
                )}

                {authSuccess && (
                  <div className="">
                    <label className="text-gray-700 font-bold">
                      Enter OTP:
                    </label>
                    <input
                      type="number"
                      name="otp"
                      value={values.otp}
                      onChange={handleChange}
                      placeholder="Enter OTP!"
                      className={`py-2 placeholder:text-sm w-full rounded-md outline-none border-gray-300 shadow-sm 0 ${
                        errors.password ? "border-red-500" : ""
                      }`}
                      required
                    />
                    {errors.password && (
                      <div className="text-red-500">{errors.password}</div>
                    )}
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full bg-slate-200 text-gray-700 hover:text-white hover:bg-orange-600 transition-all duration-300 font-medium mt-10 py-3 px-4 rounded-md"
                >
                  Submit
                </button>
              </form>
            )}
          </Formik>
          {authError && <div className="text-red-500 mt-4">{authError}</div>}
        </div>

        {showDownload && (
          <div className="bg-gray-200 p-8 rounded-lg shadow-md border-4 mt-8 border-white">
            <DownloadCSV />
          </div>
        )}
      </div>
    );
}

export default DownloadAuth
